export default {"src":"/_next/static/media/dota-2.fa556553.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};